import angular from "angular";
import StripeCard from "./StripeCard.vue";
import Vue from "vue";
import "ngVue";

export default angular
  .module("directives.stripecard", [])
  .directive("dcStripeCard", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(Vue.component("DcStripeCard", StripeCard));
    },
  ]);

